define('type/fact/Serum.Fact',['common/js/lib/Serum.Pubsub'],
  function (Pubsub) {

    'use strict';

    var REGEX_VALID_ID = /^#[a-z]+[_a-z0-9-]*$/i;

    function trackOpen (fact, articleId) {
      var ppIdFactBox = fact.getAttribute('data-id'),
        eventData = {
          category: 'fact-reference',
          action: 'fact_expand',
          label: 'pp:' + articleId,
          fieldsObject: {
            dimension1: 'pp:' + ppIdFactBox,
            dimension10: 'pp:' + articleId
          }
        };

      Pubsub.publish(Pubsub.topics.TRACK_EVENT, eventData);
    }

    function findParentArticleId (fact) {
      var articles = document.querySelectorAll('article'),
        i, article;

      for (i = 0; i < articles.length; i++) {
        article = articles.item(i);
        if (article.getAttribute('data-id') && article.querySelector('#' + fact.id)) {
          return article.getAttribute('data-id');
        }
      }

      return null;
    }

    function toggleFact(fact){
      //Read properties
      var toggleClass = ' fact--expanded',
        parentArticleId = findParentArticleId(fact),
        isCollapsed = fact.className.indexOf(toggleClass) < 0,
        maxHeights = [].map.call(fact.children, function(el){
          if (el.tagName === 'FIGURE'){
            return 'calc(14px + ' + Math.round(el.scrollHeight / el.scrollWidth * 100) + 'vw)';
          }
          return (el.scrollHeight) + 'px';
        });

      //Write properties
      if(!isCollapsed){
        maxHeights.forEach(function(height, i){
          fact.children[i].style.maxHeight = height;
        });
      }

      // track factbox expansion
      if (isCollapsed && parentArticleId) {
        trackOpen(fact, parentArticleId);
      }

      fact.className = (fact.className + toggleClass).replace(toggleClass + toggleClass, '');
      maxHeights.forEach(function(height, i){
        fact.children[i].style.maxHeight = isCollapsed ? height : '';
      });
    }

    //Listen to bubbled click on fact expand links
    document.addEventListener('click', function(event){
      for(var el = event.target; el; el = el.parentElement){
        var fact = el.hash && REGEX_VALID_ID.test(el.hash) && document.querySelector('.fact' + el.hash);
        if(fact){
          event.preventDefault();
          toggleFact(fact);
        }
      }
    });
  });

